import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase-Konfiguration des Web-Projekts (öffentlich, Schutz über Rules)
const firebaseConfig = {
  apiKey: "AIzaSyDguwM9OX1AZGD--XtrWirPXLqtcbCfXyw",
  authDomain: "nfl-tippspiel-3875c.firebaseapp.com",
  projectId: "nfl-tippspiel-3875c",
  storageBucket: "nfl-tippspiel-3875c.firebasestorage.app",
  messagingSenderId: "379044867675",
  appId: "1:379044867675:web:0b3185e7974742271e197e"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Lokale Emulatoren statt Produktion: `npm run start:emu` setzt
// REACT_APP_EMULATOR=1 (siehe docs/EMULATOR.md). Ports wie in firebase.json.
export const nutztEmulator = process.env.REACT_APP_EMULATOR === '1';

if (nutztEmulator) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(getFunctions(app, 'europe-west3'), 'localhost', 5001);
  console.info('🧪 Kessel MVP läuft gegen die Firebase-Emulatoren (localhost)');
}
